(function () {
  if (window.__sitraMegaInit) return;
  window.__sitraMegaInit = true;
  var SEL = '[data-sitra-rail-item]';
  var timer;

  function activate(item) {
    var root = item.closest('[data-sitra-root]');
    if (!root || item.classList.contains('is-active')) return;
    var key = item.getAttribute('data-sitra-rail-item');
    root.querySelectorAll(SEL).forEach(function (el) {
      var on = el === item;
      el.classList.toggle('is-active', on);
      var btn = el.querySelector('.sitra-mega__rail-link');
      if (btn && btn.tagName === 'BUTTON') {
        if (on) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      }
    });
    root.querySelectorAll('[data-sitra-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-sitra-panel') === key);
    });
  }

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest(SEL);
    if (!item || !item.closest('.sitra-mega--desktop')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { activate(item); }, 60);
  });

  document.addEventListener('focusin', function (e) {
    var item = e.target.closest && e.target.closest(SEL);
    if (item && item.closest('.sitra-mega--desktop')) activate(item);
  });

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest(SEL);
    if (!item || !item.closest('.sitra-mega--mobile')) return;
    e.preventDefault();
    activate(item);
  });
})();
